import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getDocuments,
  postDocuments,
} from "../../redux/actions/actionDocument";
import { getClientes } from "../../redux/actions/actionClient";
import { getItems } from "../../redux/actions/actionItem";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { PDFViewer } from "@react-pdf/renderer";
import DocumentPDF from "./documentPDF";
import NewWindow from "react-new-window";

export default function DocumentsCreate() {
  let dateAux = format(new Date(), "yyyy/MM/dd");

  const initialForm = {
    numberDocument: "",
    quantityItems: [],
    addressEvent: "",
    dateSend: new Date(),
    dateReception: new Date(),
    //user_id: "",
    client_id: "",
    note: "",
  };

  //console.log(new Date(dateAux))
  //console.log(new Date())
  const products = {
    item: "",
    name: "",
    descrip: "",
    quantity: "",
  };

  const dispatch = useDispatch();
  const documents = useSelector((state) => state.documents.allDocuments);
  const clients = useSelector((state) => state.clientes.allClientes);
  const items = useSelector((state) => state.items.allItems);
  const navigate = useNavigate();
  const [form, setForm] = useState(initialForm);
  const [startDate] = useState(new Date());
  const [product, setProduct] = useState(products);
  const [verPDF, setVerPDF] = useState(false);
  const [errors, setErrors] = useState({});

  console.log(documents);

  useEffect(() => {
    dispatch(getDocuments());
    dispatch(getClientes());
    dispatch(getItems());
  }, [dispatch]);

  const newDocuments = structuredClone(documents)
  console.log(newDocuments[0])

  const codeDocument = (form.numberDocument = documents[1] + 1);
  console.log(parseInt(codeDocument))

  const auxClients = clients.filter((e) => e._id === form.client_id);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const validateForm = (form) => {
    let errors = {};

    if (!form.client_id.trim()) {
      errors.client_id = "Debe elegir un cliente";
    }

    if (!form.addressEvent.trim()) {
      errors.addressEvent = "Debe ingresar un domicilio";
    }
  };

  // const handleBlurChange = (e) => {
  //   // esta función lanza las validaciones al perder el foco las propiedades del formulario.
  //   handleChange(e);
  //   setForm(validateForm(form))
  //   //setErrors(validateForm(form)) //validateForm se ejecuta dentro del estado de error, y llenara el objeto vacío con los errores
  // };

  const handleBlurQuantity = (e) => {
    handleQuantity(e);
  };

  const handleCliente = (e) => {
    setForm({
      ...form,
      client_id: e.value,
    });
  };

  const handleItem = (e) => {
    console.log(e);
    const auxDescription = items.filter((x) => x._id === e.value);

    setProduct({
      ...product,
      item: e.value,
      name: e.label[2],
      descrip: auxDescription[0].description,
    });
  };

  const handleQuantity = (e) => {
    if(e.key === "Enter"){
      console.log("Funcionar enter")
    }
    const { value } = e.target;
    console.log(value);

    setProduct({
      ...product,
      [e.target.name]: value,
    });
  };

  const handleSuma = (e) => {
    const { value } = e.target;
    // console.log(value)

    if (product.item === "" || product.quantity === "") {
      Swal.fire("Debe seleccionar artículo y cantidad");
      return;
    }

    if (parseInt(product.quantity) === 0) {
      Swal.fire("Debe ingresar un valor mas alto a 0");
      return;
    }

    // const auxItem = form.quantityItems.find(x => x.item === product.item)
    // console.log(auxItem)
    //  if(auxItem){
    //   handleQuantity(value)
    //  }

    const inicio = new Date(form.dateSend);
    const fin = new Date(form.dateReception);
    // const inicio = new Date("2023-06-01T00:00:00");
    // const fin = new Date("2023-06-30T00:00:00");
    const UN_DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24;
    const INTERVALO = UN_DIA_EN_MILISEGUNDOS * 7; // Cada semana
    const formateadorFecha = new Intl.DateTimeFormat({ dateStyle: "medium" });
    let stockPermitido = false;
    console.log(inicio)
    for (
      let i = inicio;
      i <= fin;
      i = new Date(i.getTime() + UN_DIA_EN_MILISEGUNDOS)
    ) {
      // Iteramos de fecha de ingreso a fecha de recepcion por dia
      //console.log(format(i, "yyyy/MM/dd"))
      //let stockPermitido = false;
      let day = format(i, "yyyy/MM/dd");

      const documentsFilter = documents[0].filter(
        (e) =>
          new Date(e.dateReception) >= new Date(day) &&
          new Date(e.dateSend) <= new Date(day)
      ); //filtramos los remitos que esten activos el dia que se esta iterando
      console.log(documentsFilter);

      const auxItem = documentsFilter.map((e) =>
        e.quantityItems.find((x) => x.item === product.item)
      ); // filtramos los articulos que ingresamos en el formulario
      console.log(auxItem);

      const auxItemFilter = auxItem.filter(e => e !== undefined)
      console.log(auxItemFilter)
      

      if (auxItemFilter !== undefined) {
        console.log("ok");
        let sumaStock = 0; // recorremos las diferentes cantidades del articulo y las sumamos
        auxItemFilter.forEach(function (x) {
          console.log(x.quantity);
          sumaStock = parseInt(x.quantity) + sumaStock;
        });
        console.log(sumaStock);

        const stockItem = items.filter((e) => e._id === product.item); //filtramos el articulo desde nuestro array de articulos
        console.log(stockItem);

        const resultadoStock = stockItem[0].stockTotal - sumaStock; // restamos la suma de cantidades al stock total, dandonos por resultado el stock libre por dia
        console.log(resultadoStock);
        console.log(product.quantity);

        if (product.quantity > resultadoStock) {
          // si la cantidad ingresada es mayor al resultado de stock da verdadero, esto nos indica que no hay stock

          Swal.fire(
            "Acaba de ingresar una cantidad que supera al stock actual"
          );
          return (stockPermitido = true);
        }
      } else {
        const stockItem = items.find((e) => e._id === product.item); //filtramos el articulo desde nuestro array de articulos
        console.log(stockItem);

        if (product.quantity > stockItem.stockTotal) {
          Swal.fire(
            "Acaba de ingresar una cantidad que supera al stock actual"
          );
          return;
        }

        console.log("bye");
      }

      console.log(formateadorFecha.format(i));
    }

    //----
    setForm({
      ...form,
      quantityItems: [...form.quantityItems, product],
    });
    setProduct({
      item: product.item,
      name: product.name,
      quantity: "",
    });

    //  if (product.item !== undefined && product.quantity !== undefined) {
    //   //console.log(product.item + " " + product.quantity)
    //   const auxItem = items.filter( e => product.item === e._id)
    //   //console.log(auxItem[0].name)
    //   const auxSuma = auxItem[0].stock - product.quantity
    //   if(auxSuma < 0) {
    //     Swal.fire("Acaba de ingresar una cantidad que supera al stock actual")
    //   }
    //   else {
    //     setForm({
    //       ...form,
    //       quantityItems: [...form.quantityItems, product],
    //     });
    //     // setProduct({
    //     //   item: "",
    //     //   name: "",
    //     //   quantity: "",
    //     // });
    //   }
    // }
  };

  //console.log(product);

  const handleDate = (date) => {
    console.log(date);
    setForm({
      ...form,
      dateSend: date
    });
  };

  const handleDateReception = (date) => {
    if (date > form.dateSend) {
      setForm({
        ...form,
        dateReception: date
      });
    } else {
      Swal.fire(
        "La fecha de recepción no puede ser anterior a la fecha de envío"
      );
    }
  };

  const handleDeleteArt = (e) => {
    //console.log(e.target);
    setForm({
      ...form,
      quantityItems: form.quantityItems.filter(
        (x) => x.item !== e.target.value
      ),
    });
  };

  //console.log(errors);

  //const handleItems = (e) => {}
  const opendPDF = () => {
    setVerPDF(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(form);

    if (
      form.numberDocument === "" ||
      !form.quantityItems.length ||
      form.addressEvent === "" ||
      form.dateSend === "" ||
      form.dateReception === "" ||
      form.client_id === ""
    ) {
      return Swal.fire("Hay campos sin completar");
    }

    // await Swal.fire({
    //     title: "Imprime",
    //     showCancelButton: true,
    //     confirmButtonText: "OK",
    //   }).then((result) => {
    //     if(result.isConfirmed){
    //     setVerDocumento(true)
    //     //navigate("/documentos/pdf")
    //     }
    //   })

    dispatch(postDocuments(form));
    setForm({
      numberDocument: "",
      quantityItems: [],
      addressEvent: "",
      dateSend: "",
      dateReception: "",
      descriptions: "",
      //user_id: "",
      client_id: "",
      note:""
    });

    setTimeout(() => {
      window.location.reload()        
    }, "500");
  };

  return (
    <div className="container m-16">
      <div className="">
        <div>
          <p className="text-xl pb-4 underline">Remitos - Nuevo</p>
        </div>
        <div className="flex flex-row justify-between text-[10pt] font-semibold border-b-2">
          <div className="">Fecha: {dateAux}</div>
          <div>
            <label className="">N° Documento: </label>
            <input
              className=""
              type="text"
              name="numberDocument"
              placeholder=""
              onChange={handleChange}
              value={"0" + "" + codeDocument}
              requerid="true"
            />
          </div>
        </div>

        <div className=" border-b-2 pb-2">

          <div className="flex flex-row py-2">
            <div className="text-[10pt] font-semibold">
              <label>Seleccionar Cliente</label>
            </div>
            <div className="">
              <Select
                styles={{
                  control: (base) => ({ ...base, height: "20px", width:"300px"}),
                  option: (base) => ({ ...base, width:"300px"}),
                  
                }}
                options={clients.map((e) => ({ label: e.name, value: e._id }))}
                onChange={handleCliente}
              />
              {errors.client_id && (
                <p className="text-red-900">{errors.client_id}</p>
              )}
            </div>
            
          </div>

          <div className="w-full">
            {form.client_id === "" ? (
              <div className="flex flex-row flex-wrap text-[10pt] font-semibold">
                <div className="w-1/3">Compañia: </div>
                <div className="w-1/3">Nombre: </div>
                <div className="w-1/3">Apellido: </div>
                <div className="w-1/3">Direccion: </div>
                <div className="w-1/3">Telefonos: </div>
                <div className="w-1/3">Email: </div>
              </div>
            ) : (
              <div className="w-full">
                {auxClients.map((e) => {
                  return (
                    <div key={e._id} className="flex flex-row flex-wrap text-[10pt] font-semibold">
                      <div className="w-1/3">Compañia: {e.nameCompany}</div>
                      <div className="w-1/3">Nombre: {e.name}</div>
                      <div className="w-1/3">Apellido: {e.lastName}</div>
                      <div className="w-1/3">Direccion: {e.address}</div>
                      <div className="w-1/3">Telefonos: {e.telephoneNumber}</div>
                      <div className="w-1/3">Email: {e.email}</div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-row border-b-2 py-2 text-[10pt] font-semibold w-full">
          <div className="w-2/3">
            <label>Domicilio de Evento</label>
            <input
              className="border rounded w-2/3"
              type="text"
              name="addressEvent"
              onChange={handleChange}
              value={form.addressEvent}
            />
            {errors.addressEvent && (
              <p className="text-red-900">{errors.addressEvent}</p>
            )}
          </div>
          <div className="w-1/3">
            <label>Fecha de envío</label>
            <DatePicker
              selected={startDate}
              onChange={handleDate}
              //onBlur={handleBlurDate}
              value={form.dateSend ? format(form.dateSend, "dd/MM/yyyy") : null}
            />
          </div>
          <div className="w-1/3">
            <label>Fecha de Recepción</label>
            <DatePicker
              selected={startDate}
              onChange={handleDateReception}
              value={form.dateReception ? format(form.dateReception, "dd/MM/yyyy") : null}
            />
          </div>
        </div>
        <div className="pt-2 border-b-2 pb-2 text-[10pt] font-semibold">
          <label className="mr-4">Notas</label>
          <input
            className="border rounded w-1/2 h-6"
            type="text"
            name="note"
            onChange={handleChange}
            value={form.note}
          />
        </div>
          <div className="flex flex-row w-full">
            <label className="w-1/3 text-[10pt] font-semibold">Seleccionar Articulos</label>
            <label className="w-52 pl-4 text-[10pt] font-semibold">Cantidad</label>
          </div>
          <div className="flex flex-row w-full">
            <div className="w-1/3">
              <Select
                options={items.map((e) => ({
                  label: [e.idItem, "- ", e.name, " - ", e.description],
                  value: e._id,
                }))}
                onChange={handleItem}
              />
            </div>
            <div className="w-52 pl-4 pt-1">              
                <input
                  className="border rounded w-24 h-8"
                  type="number"
                  name="quantity"
                  onChange={handleQuantity}
                  //onKeyDown={handleSuma}                  
                  onBlur={handleBlurQuantity}
                  value={product.quantity}
                />              
            </div>
            <div className="w-24 pt-1 rounded text-center items-center font-semibold bg-slate-500 hover:bg-slate-300">
              <button onClick={handleSuma}>OK</button>
            </div>
          </div>
        <div className="pt-4">
          <div className="flex flex-row text-[12pt] font-bold w-11/12">
            <div className="w-2/3">Articulo</div>
            <div className="w-11/12">Descripcion</div>
            <div className="w-1/5 text-center font-semibold">Cantidad</div>  
            <div className="w-12"></div>          
          </div>
          <div className="border-y-2 border-x-2 border-black w-11/12">
            {form.quantityItems.map((e, index) => {
              return (
                <div
                  key={index}
                  className="flex flex-row text-[10pt] border-b-2 border-black"
                >
                  <div className="w-2/3">{e.name}</div>
                  <div className="w-11/12">{e.descrip}</div>
                  <div className="w-1/5  border-black text-center font-semibold">{e.quantity}</div>
                  <button value={e.item} onClick={handleDeleteArt} className="w-10 border-l-2 border-black bg-red-500 hover:bg-red-600 text-white font-bold">
                    X
                  </button>
                </div>
              );
            })}
          </div>
        </div>
        <div className="flex flex-row justify-around w-1/3">
        <div>
          <button
            className="mt-12 p-4 rounded bg-sky-500 text-white"
            onClick={handleSubmit}
          >
            Guardar
          </button>
        </div>
        <div>
          <button
            className="mt-12 p-4 rounded bg-sky-500 text-white"
            onClick={opendPDF}
          >
            Ver PDF
          </button>
        </div>
        </div>
        <div>
          {verPDF ? (
            <div
              className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-0-sm
              flex flex-col justify-center items-center"
            >
              <div className="bg-red-500 w-1/12 text-center rounded hover:bg-red-600">
                <button
                  className="text-black font-bold hover:text-white"
                  onClick={() => setVerPDF(false)}
                >
                  Cerrar
                </button>
              </div>
              {/* <NewWindow> */}
              <div>
                <DocumentPDF />
              </div>
              {/* </NewWindow> */}
            </div>
          ) : null}
        </div>
        {/* <div>
          {verDocumento ? (
            <div>
              <button onClick={()=> setVerDocumento(false)}>X</button>
              <PDFViewer style={{ width: "100%", height: "90vh" }}>
                <DocumentPDF documento={form}/>
              </PDFViewer>
            </div>
          ) : null}
        </div> */}
      </div>
      {/* <form onSubmit={handleSubmit}>
          <div>
            <input
              type="submit"
              value="Guardar"
              onClick={() => window.location.reload()}
            />
          </div>
      </form> */}
    </div>
  );
}
